class ToastContainer extends HTMLElement {
  constructor() {
    super();
    this.toastDetails = {
      timer: parseInt(this.getAttribute('data-timer') || '5000', 10),
      success: {
        icon: this.getAttribute('data-success-icon'),
        color: 'brand-success-500',
      },
      error: {
        icon: this.getAttribute('data-error-icon'),
        color: 'brand-error-500',
      },
      warning: {
        icon: this.getAttribute('data-warning-icon'),
        color: 'brand-warning-500',
      },
      info: {
        icon: this.getAttribute('data-info-icon'),
        color: 'brand-info-500',
      },
    };
  }

  createToast(id, text, product) {
    const {icon, color} = this.toastDetails[id];
    const toastNotification = new ToastNotification(
      id,
      text,
      icon,
      color,
      product,
    );
    return toastNotification;
  }

  addAndShowToast(id, text, product) {
    const toast = this.createToast(id, text, product);
    this.appendChild(toast);
    toast.classList.add('leo-block');
    toast.setAttribute(
      'timeoutId',
      `${setTimeout(
        () => this.removeAndHideToast(toast),
        this.toastDetails.timer,
      )}`,
    );
  }

  removeAndHideToast(toast) {
    toast.classList.remove('leo-block');
    toast.classList.add('leo-hidden');
    const timeoutId = Number(toast.getAttribute('timeoutId'));
    if (timeoutId) clearTimeout(Number(timeoutId));
    setTimeout(() => toast.remove(), 500);
  }
}

customElements.define('toast-container', ToastContainer);

class ToastNotification extends ToastContainer {
  constructor(id, text, icon, color, product) {
    super();
    this.id = id || '';
    this.text = text || '';
    this.icon = icon || '';
    this.color = color || 'black';
    this.product = product ?? null;
    console.log('product', this.product);
  }

  connectedCallback() {
    if (this.product) {
      this.renderProductToastNotification();
    } else {
      this.renderNormalToastNotification();
    }
  }
  renderNormalToastNotification() {
    this.className = `leo-max-w-[620px] leo-w-full leo-ml-0 md:leo-ml-5 sm:leo-ml-0 sm:leo-w-auto leo-h-auto leo-min-w-[200px] leo-relative leo-overflow-hidden leo-list-none leo-rounded-[50px] leo-py-[6px] leo-pl-4 leo-pr-5 leo-mb-2.5 leo-flex leo-bg-${this.color} leo-justify-between leo-items-center leo-gap-2 leo-animate-show-toast leo-duration-300 leo-ease leo-text-xxs`;
    this.innerHTML = `
        <span>
          ${this.renderIcon()}
        </span>
        <div class="column leo-flex leo-justify-${
          this.product ? 'between' : 'start'
        } leo-items-center leo-bg-${this.color}">
            <span class="leo-text-brand-base-white leo-text-body leo-text-xs leo-font-medium leo-leading-[120%] leo-tracking-null">${
              this.text
            }</span>
            ${
              this.product
                ? `<span class="leo-text-brand-base-white leo-text-body leo-text-xs leo-font-medium leo-leading-[120%] leo-tracking-null">
                <a href="/products/${this.product.handle}" class="leo-text-brand-base-white leo-text-body leo-text-xs leo-font-medium leo-leading-[120%] leo-tracking-null">
                  View Products
                </a>
            </span>`
                : ''
            }
        </div>
        <toast-remove class="leo-block leo-pl-2.5">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.295 7.115C18.6844 6.72564 18.6844 6.09436 18.295 5.705C17.9056 5.31564 17.2744 5.31564 16.885 5.705L12 10.59L7.115 5.705C6.72564 5.31564 6.09436 5.31564 5.705 5.705C5.31564 6.09436 5.31564 6.72564 5.705 7.115L10.59 12L5.705 16.885C5.31564 17.2744 5.31564 17.9056 5.705 18.295C6.09436 18.6844 6.72564 18.6844 7.115 18.295L12 13.41L16.885 18.295C17.2744 18.6844 17.9056 18.6844 18.295 18.295C18.6844 17.9056 18.6844 17.2744 18.295 16.885L13.41 12L18.295 7.115Z" fill="white"/>
          </svg>
        </toast-remove>`;
  }

  renderProductToastNotification() {
    this.className = `leo-max-w-[620px] leo-w-full leo-ml-0 md:leo-ml-5 sm:leo-ml-0 sm:leo-w-auto leo-h-auto leo-min-w-[200px] leo-relative leo-overflow-hidden leo-list-none leo-rounded-[12px] leo-p-[12px] leo-mb-2.5 leo-flex leo-bg-brand-base-white leo-justify-between leo-items-center leo-gap-2 leo-animate-show-toast leo-duration-300 leo-ease leo-text-xxs leo-outline leo-outline-1 leo-outline-offset-[-1px] leo-outline-brand-grey-200`;
    this.innerHTML = `
        <span>
          <img src="${this.product.image}" alt="${this.product.title}" class="leo-w-[130px] leo-h-[130px] leo-aspect-square leo-object-contain leo-bg-[#FBF9FC]" />
        </span>
        <div class="column leo-flex leo-flex-col leo-justify-start leo-items-start">
          <div class="leo-w-full leo-flex leo-justify-between leo-items-start leo-border-b leo-border-brand-grey-200">
            <span class="leo-text-body leo-text-md md:leo-text-2xl leo-p-4 leo-pt-0 leo-font-medium leo-leading-[120%] leo-tracking-null leo-text-${this.color}">${this.text}</span>
            <toast-remove class="leo-block leo-pl-2.5">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.295 7.115C18.6844 6.72564 18.6844 6.09436 18.295 5.705C17.9056 5.31564 17.2744 5.31564 16.885 5.705L12 10.59L7.115 5.705C6.72564 5.31564 6.09436 5.31564 5.705 5.705C5.31564 6.09436 5.31564 6.72564 5.705 7.115L10.59 12L5.705 16.885C5.31564 17.2744 5.31564 17.9056 5.705 18.295C6.09436 18.6844 6.72564 18.6844 7.115 18.295L12 13.41L16.885 18.295C17.2744 18.6844 17.9056 18.6844 18.295 18.295C18.6844 17.9056 18.6844 17.2744 18.295 16.885L13.41 12L18.295 7.115Z" fill="black"/>
              </svg>
            </toast-remove>
          </div>
          <div class="leo-w-full leo-flex leo-flex-col leo-justify-between leo-items-start leo-p-3 leo-pb-0">
            <div class="leo-w-full leo-flex leo-flex-col leo-justify-between leo-items-start">
              <h6 class="leo-text-brand-base-black leo-text-body leo-text-sm leo-font-medium leo-leading-[120%] leo-tracking-null">${this.product.title}</h6>
              <span class="leo-w-full leo-flex leo-gap-2 leo-justify-start leo-items-center leo-mt-2">
                <span class="leo-text-brand-base-black leo-text-body leo-text-md leo-font-medium leo-leading-[120%] leo-tracking-null">${this.product.price}</span>
                <span class="leo-text-brand-base-black leo-text-body leo-text-sm leo-font-normal leo-leading-[120%] leo-tracking-null strike-out">${this.product.compareAtPrice}</span>
              </span>
            </div>
            <a href="/products/${this.product.handle}" class="leo-py-2 md:leo-py-3 leo-px-3 md:leo-px-7 leo-text-brand-base-white leo-mt-4 leo-text-body leo-text-xs md:leo-text-sm leo-font-medium leo-leading-[120%] leo-tracking-null leo-bg-${this.color} leo-rounded-full">
              View Product
            </a>
          </div>
        </div>
        `;
  }

  applyFillColor(svgString, color) {
    return svgString.replace('<svg', `<svg fill="leo-text-${color}"`);
  }

  renderIcon() {
    // Check if icon is an SVG by trying to parse it as HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(this.icon, 'text/html');
    const isSVG = doc.querySelector('svg');
    // If it's an SVG, apply the color using the applyFillColor function
    if (isSVG) {
      return this.icon; // Return the SVG as is, or you can apply a fill color if needed
      // Example: return this.applyFillColor(this.icon, this.color); // Apply custom fill color to the SVG
      // return this.applyFillColor(this.icon, this.color); // Apply custom fill color to the SVG
    }

    // If it's not an SVG, return FontAwesome icon (fallback case)
    return `<i class="fa-solid ${this.icon} leo-text-${this.color}"></i>`;
  }

  removeToast(toast) {
    this.removeAndHideToast(toast);
  }
}

customElements.define('toast-notification', ToastNotification);

class ToastRemove extends ToastNotification {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener('click', () =>
      this.removeToast(this.closest('toast-notification')),
    );
  }
}

customElements.define('toast-remove', ToastRemove);

class ShowToast {
  constructor(id, text, product) {
    // Find or create the ToastContainer
    let container = document.querySelector('toast-container');
    if (!container) {
      container = document.createElement('toast-container');
      document.body.appendChild(container);
    }

    // Add and show the toast
    container.addAndShowToast(id, text, product);
  }
}

// Usage Example:
// This will create a toast container (if not already present), and show a toast notification
// new ShowToast('info', 'Toast Notification Integration Successful!');
